import { createFileRoute } from '@tanstack/react-router'
import { useGoBack } from '@/hooks/use-go-back'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { SellerForm } from '@/features/sellers/components/seller-form'
import { useSellerQuery } from '@/features/sellers/api/sellers.query'
import { useRequireAdmin } from '@/features/auth'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute('/_authenticated/sellers/$sellerId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { sellerId } = Route.useParams()
  const goBack = useGoBack()
  const { canAccess, isLoading: isAuthLoading } = useRequireAdmin('/sellers/$sellerId', { sellerId })
  const { data: seller, isLoading } = useSellerQuery(sellerId)

  if (isAuthLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="size-8" />
      </div>
    )
  }
  if (!canAccess) return null

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/sellers/$sellerId', params: { sellerId } })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica Venditore</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    )
  }

  if (!seller) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/sellers' })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica Venditore</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">Venditore non trovato</p>
        </div>
      </div>
    )
  }
  
  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/sellers/$sellerId', params: { sellerId } })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Modifica Venditore</h1>
      </div>
      <SellerForm seller={seller} />
    </div>
  )
}
